export const LAST_CHAT_ID_KEY = "vibe-chat-last-session-id";

export const OPEN_VIBECHAT_EVENT = "open-vibechat";

export interface OpenVibeChatEventDetail {
  prompt?: string;
  newChat?: boolean;
}

export const DEFAULT_CHAT_TITLE = "New chat";

export const VIBE_CHAT_BACKGROUND = "#fafafa";

export const CHAT_INPUT_SHADOW_CLASS =
  "shadow-[0_8px_40px_-8px_rgba(0,0,0,0.12),0_2px_12px_-2px_rgba(0,0,0,0.06)]";

export const CHAT_INPUT_PLACEHOLDER = "Ask a question... (type @ to mention)";

export const CHAT_EMPTY_STATE_HEADING = "How can I help you today?";

export const CHAT_MESSAGES_CONTAINER_CLASS =
  "flex-1 overflow-y-auto px-5 py-5 pb-36 [container-type:inline-size]";

export const CHAT_BOTTOM_GRADIENT_CLASS =
  "pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#fafafa] via-[#fafafa]/95 to-transparent";

export const CHAT_BODY_FADE_TRANSITION = {
  duration: 0.18,
  ease: "easeOut" as const,
};

export const CHAT_INPUT_LAYOUT_ID = "vibe-chat-input";

export const CHAT_INPUT_LAYOUT_TRANSITION = {
  type: "spring" as const,
  stiffness: 420,
  damping: 34,
  mass: 0.9,
};

export const CHAT_EMPTY_STATE_DECORATION_DELAY_MS = 220;

export const CHAT_EMPTY_STATE_DECORATION_TRANSITION = {
  duration: 0.16,
  ease: "easeOut" as const,
};
